module.exports = __webpack_public_path__ + "images/suzuki_smallb370941d94060df3c85b59837e162270.png";